import { render } from "./MappingConfiguration.vue?vue&type=template&id=ee5fbe6a&ts=true"
import script from "./MappingConfiguration.vue?vue&type=script&lang=ts"
export * from "./MappingConfiguration.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__